import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import HomePage from './HomePage';

const theme = createTheme({
  typography: {
    fontFamily: '"Microsoft Yahei", Arial, sans-serif',
  },
});

export default function App() {
  return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HomePage />
      </ThemeProvider>
  );
}
